// src/store/modules/landing-page.js
import { GET_EVENT_DETAILS, GET_PARTICIPANTS, UPDATE_PARTICIPANT, UPDATE_STATUS_PARTICIPANT } from '@/store/action-types';
import { EVENT_NAMESPACE } from '@/store/namespace-types';
import { SET_PARTICIPANTS, SET_PARTICIPANT, SET_PARTICIPANTS_REQUESTED_EVENT } from '@/store/mutation-types';
import { GET_PARTICIPANT, GET_PARTICIPANTS_FOR_EVENT } from '@/store/getters-types';
import participantModel from '@/models/participants/participants';

export default {
  namespaced: true,
  actions: {
    async [GET_PARTICIPANTS]({ commit, state }, { eventId }) {
      commit(SET_PARTICIPANTS_REQUESTED_EVENT, eventId);
      const participants = await participantModel.getAll(eventId);
      // A newer request for another event may have started meanwhile; its result wins.
      if (String(state.requestedEventId) !== String(eventId)) {
        return;
      }
      commit(SET_PARTICIPANTS, { eventId, participants });
    },
    async [UPDATE_PARTICIPANT]({ commit }, { participant }) {
      let participantOut = await participantModel.update(participant.id, participant)
      commit(SET_PARTICIPANT, { participant: participantOut })
    },
    async [UPDATE_STATUS_PARTICIPANT]({ commit, dispatch, state }, { participantId, url }) {
      await participantModel.updateStatus(url)
      let participantOut = await participantModel.get(participantId);
      commit(SET_PARTICIPANT, { participant: participantOut })
      // Releasing or cancelling a participant changes the booking counts of the event.
      if (state.eventId != null) {
        await dispatch(`${EVENT_NAMESPACE}/${GET_EVENT_DETAILS}`, { eventId: state.eventId }, { root: true })
      }
    },
  },
  mutations: {
    [SET_PARTICIPANTS_REQUESTED_EVENT](state, eventId) {
      state.requestedEventId = eventId
    },
    [SET_PARTICIPANTS](state, { eventId, participants }) {
      let tempMap = new Map()
      participants.forEach(element => {
        tempMap.set(element.id, element);
      });
      state.participantlist = tempMap
      state.eventId = eventId
    },
    // Single-participant responses omit contact person and bank data of the list,
    // so they are merged into the stored entry instead of replacing it.
    [SET_PARTICIPANT](state, { participant }) {
      const existing = state.participantlist.get(participant.id)
      state.participantlist.set(participant.id, { ...existing, ...participant })
    },
  },
  getters: {
    // ...
    // Participants of the given event, or null while that event's list is not loaded yet.
    [GET_PARTICIPANTS_FOR_EVENT]: (state) => (eventId) => {
      if (eventId == null || String(state.eventId) !== String(eventId)) {
        return null;
      }
      return Array.from(state.participantlist.values());
    },
    [GET_PARTICIPANT]: (state) => (participantId) => {
      let out = state.participantlist.get(participantId);
      return out;
    },
  },
  // We initialize the state with
  // an empty LandingPage object.
  state: {
    participantlist: new Map(),
    // Event the participant list belongs to, and the event most recently requested.
    eventId: null,
    requestedEventId: null,
    config: {},
  },
};